import SoftBox from "components/SoftBox";
import Card from "@mui/material/Card";
import SoftTypography from "components/SoftTypography";
import React, { useContext } from "react";
import StatusBadge from "cxfcomponents/StatusBadge";
import { ThemedMailIcon } from "assets/CXFIcons/Static";
import { Badge } from "@mui/material";
import { UsersStatusContext } from "context/AppProvider/UsersStatusContext";
import { Link } from "react-router-dom";
import DefaultUserAvatar from "layouts/pages/account/components/Header/components/DefaultUserAvatar";
import { UserContext } from "context/AppProvider/UserContext";
import SoftAvatar from "components/SoftAvatar";
import useThemeDetector from "hooks/useThemeDetector";

const Tiles = ({ rows }) => {
   const { usersStatus } = useContext(UsersStatusContext);
   const { userData } = useContext(UserContext);
   const { isDarkMode } = useThemeDetector();

   const userStatusBadgeColor = (status) => {
      if (status === "active") {
         return "success";
      } else {
         return "dark";
      }
   };

   const checkUserStatus = (auth0_id) => {
      if (usersStatus) {
         const userStatus = usersStatus.find((item) => item.auth0_id === auth0_id)?.status;
         return userStatus;
      }
   };

   return (
      <SoftBox
         display="grid"
         sx={{
            gridTemplateColumns: "repeat(auto-fill, minmax(410px, 1fr))",
            gap: 1,
            justifyContent: "start",
            alignItems: "stretch",
            marginBottom: "16px"
         }}
      >
         {rows.map((row, index) => (
            <Card
               key={`tile-${row.id}-${index}`}
               sx={{
                  width: "100%",
                  minWidth: "373px",
                  height: "100%",
                  boxShadow: isDarkMode ? "0px 20px 27px rgba(0, 0, 0, 0.05)" : "none",
                  margin: "0 auto",
                  padding: 3
               }}
            >
               <SoftBox
                  sx={{
                     display: "flex",
                     alignItems: "flex-start"
                  }}
               >
                  <Badge
                     variant="dot"
                     color={userStatusBadgeColor(checkUserStatus(row.values?.users?.item?.auth0_id))}
                     anchorOrigin={{
                        vertical: "bottom",
                        horizontal: "right"
                     }}
                     size="large"
                     sx={{
                        display: "flex",
                        alignItems: "center",
                        justifyContent: "center",
                        position: "relative",
                        "& .MuiBadge-dot": {
                           width: 13,
                           height: 13,
                           borderRadius: "50%",
                           zIndex: "initial",
                           bottom: 4,
                           right: 4
                        }
                     }}
                  >
                     <SoftBox
                        borderRadius="8px"
                        sx={{
                           flexShrink: 0,
                           height: {
                              xs: "64px",
                              sm: "64px",
                              lg: "94px"
                           },
                           width: {
                              xs: "64px",
                              sm: "64px",
                              lg: "94px"
                           },
                           objectFit: "cover",
                           display: "flex",
                           alignItems: "center",
                           justifyContent: "center"
                        }}
                     >
                        {row.values?.users?.item?.image ? (
                           <SoftBox
                              component="img"
                              src={row.values?.users?.item?.image}
                              sx={{
                                 height: "100%",
                                 width: "100%",
                                 borderRadius: "8px",
                                 objectFit: "cover",
                                 border: "0.5px solid #E6E6E6"
                              }}
                           />
                        ) : (
                           <SoftAvatar
                              alt="user-image"
                              shadow="sm"
                              sx={{
                                 height: "100%",
                                 width: "100%",
                                 borderRadius: "8px",
                                 objectFit: "cover",
                                 border: "0.5px solid #E6E6E6 !important"
                              }}
                           >
                              <DefaultUserAvatar firstName={userData?.first_name} lastName={userData?.last_name} size="xxxl" border="unset" variant="rounded" />
                           </SoftAvatar>
                        )}
                     </SoftBox>
                  </Badge>

                  <SoftBox
                     sx={{
                        display: "flex",
                        alignItems: "start",
                        width: "100%"
                     }}
                     ml={3}
                     mt={1}
                     lineHeight={0}
                  >
                     <SoftBox
                        sx={{
                           display: "flex",
                           alignItems: "start",
                           lineHeight: "0",
                           marginRight: "8px"
                        }}
                     >
                        <SoftBox>
                           <Link to={`/account/users/profile-overview/${row.values?.users?.item?.auth0_id}`} style={{ textDecoration: "none" }}>
                              <SoftTypography className="white-to-dark" variant="h3" fontWeight="bold" fontSize="16px">
                                 {row.values?.name}
                              </SoftTypography>
                           </Link>
                           <SoftTypography variant="h3" fontWeight="bold" fontSize="14px" marginBottom="4px">
                              {row.values?.role}
                           </SoftTypography>
                           <StatusBadge status={row.values?.status} />
                        </SoftBox>
                     </SoftBox>
                     <SoftBox sx={{ marginLeft: "auto" }}>{React.isValidElement(row.values?.action) ? React.cloneElement(row.values.action, { actionOrientation: "vertical" }) : null}</SoftBox>
                  </SoftBox>
               </SoftBox>
               <SoftBox
                  className="browse-tiles-divider"
                  sx={{
                     height: "1px",
                     backgroundColor: "#E0E1E2",
                     marginTop: "24px",
                     marginBottom: "20px"
                  }}
               />
               <SoftBox
                  sx={{
                     display: "flex",
                     alignItems: "center",
                     justifyContent: "space-between",
                     flexWrap: "wrap"
                  }}
               >
                  <SoftTypography fontSize="12px" variant="button" color="secondary" sx={{ fontWeight: 400, display: "flex", alignItems: "center" }}>
                     <ThemedMailIcon width="19px" height="19px" />
                     {row.values?.users?.item?.email_address}
                  </SoftTypography>
               </SoftBox>
            </Card>
         ))}
      </SoftBox>
   );
};

export default Tiles;
